import * as React from 'react'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'
import {AISolutionDetailLayout} from '@components/ai'

const Meta = dynamic(() => import('@components/Meta'))

export default function Textile() {
  return (
    <React.Fragment>
      <Meta title={`Textile | Datawow – ${t('layout.title')}`} />

      <section className='AISolutionDetail__introduction'>
        <div className='container'>
          <div className='grid grid--max-left'>
            <h1>
              <small>ตัวอย่าง AI Use Case ทางด้าน</small>
              Textile
            </h1>
            <div>
              <p>
                อุตสาหกรรมสิ่งทอจัดเป็นอุตสาหกรรมขนาดใหญ่ที่มีโครงสร้างในการผลิตเชื่อมโยงกันอย่างครบวงจร
                และมีความสำคัญกับประเทศไทยในด้านรายได้ที่ได้จากการส่งออกสิ่งทอสำเร็จรูป
                ซึ่งมีสัดส่วนของโรงงานสูงถึง 58.2%
                สิ่งทอสำเร็จรูปถือเป็นส่วนหนึ่งของอุตสาหกรรมสิ่งทอที่จำเป็นต้องใช้ความประณีต
                ในระยะเวลาที่ผ่านมาประเทศไทยเราจึงได้เปรียบในเรื่องของแรงงานมีฝีมือและค่าแรงที่มีราคาย่อมเยา
                แต่ปัจจุบัน การที่ประเทศอื่น เช่น จีน อินเดีย หรือเวียดนาม
                สามารถผลิตได้มีประสิทธิภาพมากขึ้น
                ทำให้ประเทศเราสูญเสียความได้เปรียบ
                ดังนั้นการนำเทคโนโลยีเข้ามาเพื่อยกระดับประสิทธิภาพการผลิต
                ลดต้นทุน ควบคุมคุณภาพ หรือคิดผลิตภัณฑ์ใหม่
                อาจเป็นทางเลือกหนึ่งเพื่อเพิ่มความสามารถในการแข่งขันในอนาคต
                และตอบสนองต่อการเปลี่ยนแปลงของตลาดได้ตลอดเวลา
                ซึ่งเราจะพูดถึงตัวอย่างนวัตกรรม AI (Artificial Intelligence)
                ที่ถูกใช้งานจริงในต่างประเทศ
                และนำมาประยุกต์ใช้กับอุตสาหกรรมของไทย
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__feature-img'>
        <img
          src='/images/ai/textile/feature1.jpg'
          srcSet='/images/ai/textile/feature1@2x.jpg 2x'
          alt='Textile'
        />
      </section>

      <section className='AISolutionDetail__section'>
        <div className='container'>
          <div className='grid grid--max-right'>
            <div>
              <h2>Textile Defect Detection</h2>
              <p>
                ในด้านของการควบคุมคุณภาพของสิ่งทอ เช่น การคัดแยกเกรดของเส้นใย
                การระบุลวดลายและลักษณะของเนื้อผ้า หรือตรวจสอบตำหนิ
                การใช้แรงงานคนเพียงอย่างเดียวอาจก่อให้เกิดความผิดพลาดทั้งจากอาการเหนื่อยล้า
                และมาตรฐานที่แตกต่างกันในแต่ละบุคคล
                เราสามารถแก้ปัญหาเหล่านี้ได้ด้วยการใช้ระบบตรวจสอบด้วยกล้องที่มี
                AI ซึ่งสามารถประมวลผลภาพแบบ Real Time ยกตัวอย่างเช่น บริษัท
                Sanlian Hope ผู้ให้บริการเทคโนโลยีเส้นใยสังเคราะห์ของจีน
                เดิมทีคนงานต้องตรวจสอบเส้นใยด้วยตาเปล่า ซึ่งมองเห็นได้แค่ 100
                เมตรสุดท้ายของผ้าแต่ละม้วน ในปี 2561 บริษัทจึงร่วมมือกับ HUAWEI
                CLOUD นำเทคโนโลยี AI
                มาใช้ปรับปรุงการตรวจสอบคุณภาพของเส้นใยสังเคราะห์ทั้งผืน
                หรือบริษัท WiseEye ที่นำหลอด LED
                และกล้องคุณภาพสูงมาติดตั้งบนสายการผลิตเพื่อแสกนรูปของชิ้นผ้า
                และเปรียบกับรูปชิ้นผ้าในระบบ หากชิ้นผ้าไม่ได้มาตรฐาน
                ก็จะแจ้งเตือนทันที โดยทางบริษัทกล่าวว่า
                จากการทดลองกับสายการผลิตจริงเป็นเวลา 6 เดือน
                พบว่าระบบนี้สามารถลดการสูญเสียที่เกิดจากชิ้นผ้าไม่ได้มาตรฐานมากกว่า
                90%
              </p>
            </div>
            <img
              src='/images/ai/textile/feature2.jpg'
              srcSet='/images/ai/textile/feature2@2x.jpg 2x'
              alt='Textile Defect Detection'
              loading='lazy'
              className='lg'
            />
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--light'>
        <div className='container'>
          <h2>
            ตัวอย่างการใช้ AI ใน<span>Color Control</span>
          </h2>

          <div className='grid grid--max-left'>
            <img
              src='/images/ai/textile/feature3.jpg'
              srcSet='/images/ai/textile/feature3@2x.jpg 2x'
              alt='Textile'
              loading='lazy'
              className='lg'
            />

            <p>
              เรื่องสีของผลิตภัณฑ์สิ่งทอก็เป็นอีกประเด็นที่สำคัญ
              และมีผลกับการตัดสินใจเลือกซื้อของผู้บริโภค
              ความแตกต่างของเฉดสีเพียงเล็กน้อยอาจเป็นเหตุให้ร้านผู้ผลิตต้องดึงสินค้าทั้งชุดออกจากหน้าร้าน
              ในอดีตเรามักใช้เครื่องจักรคู่กับคนเพื่อตรวจสอบซ้ำ หากเราสามารถนำ
              AI ที่สามารถจำแนกและจับคู่สีให้ตรงตามคำอธิบาย และเรียนรู้ค่า Error
              ที่ผู้บริโภคยังคงรับได้ (Tolerance) โดยอัตโนมัติ
              ก็จะช่วยลดค่าใช้จ่ายและเวลาที่เสียไปจากการใช้ทั้งคนและเครื่องจักร
              ตัวอย่างของนวัตกรรมนี้ เช่น บริษัท Datacolor
              ให้บริการแพลตฟอร์มตรวจสอบและควบคุมคุณภาพสีในอุตสาหกรรมต่าง ๆ
              ซึ่งต้องการความแม่นยำของสีที่สูง เช่น สิ่งทอ เครื่องเขียน
              หรือผลิตภัณฑ์เพื่อความสวยงาม ในหลายประเทศทั้ง เยอรมนี อังกฤษ
              หรือบังกลาเทศ
            </p>
          </div>

          <img
            src='/images/ai/textile/feature3.jpg'
            srcSet='/images/ai/textile/feature3@2x.jpg 2x'
            alt='Textile'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>

      <section className='AISolutionDetail__card'>
        <div className='container'>
          <h2>
            ตัวอย่างการใช้ AI ใน<span>Non-manufacturing</span>
          </h2>
          <div className='AISolutionDetail__card__body'>
            <div>
              <p>
                นอกจากตัวอย่างการใช้งานในสายการผลิตข้างต้นแล้ว AI
                ยังสามารถถูกนำไปใช้ในด้านอื่น ๆ ได้อีกด้วย เช่น การนำ AI
                ไปใช้ในเว็บไซต์เพื่ออำนวยความสะดวกให้กับผู้เข้าชมโดยอาจจะเป็น
                Visual Search ที่ผู้เข้าชมสามารถค้นหาผลิตภัณฑ์ที่คล้ายกันด้วยรูป
                หรือเทคโนโลยี Virtual Try-on ที่จำลองเสื้อผ้าลงบนตัวคน
                ด้วยเทคโนโลยี AR (Augmented Reality) คู่กับ AI
                ซึ่งนอกจากจะช่วยผู้เข้าชมได้รับประสบการณ์ช็อปปิ้งที่แปลกใหม่
              </p>
              <p>
                ระบบนี้ยังช่วยผู้บริโภคที่ไม่ต้องการออกไปช็อปปิ้งในช่วงการระบาดของ
                Covid-19 ให้สามารถเข้าถึงผลิตภัณฑ์ของร้านได้อีกด้วย
                หรืออาจจะเป็นการนำ AI มาช่วยคิดผลิตภัณฑ์ใหม่ ๆ ด้วยเทคโนโลยี
                Gans และ Style transfer
              </p>
            </div>

            <img
              src='/images/ai/textile/feature4.jpg'
              srcSet='/images/ai/textile/feature4@2x.jpg 2x'
              loading='lazy'
              alt='Non-manufacturing'
            />
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--dark'>
        <div className='container'>
          <h2>Conclusion</h2>

          <div className='grid grid--max-left'>
            <img
              src='/images/ai/textile/feature5.jpg'
              srcSet='/images/ai/textile/feature5@2x.jpg 2x'
              alt='Textile'
              loading='lazy'
              className='lg'
            />
            <div>
              <p>
                ตัวอย่างข้างต้นเป็นเพียงส่วนหนึ่งของการนำ AI
                มาใช้ในอุตสาหกรรมสิ่งทอ ซึ่งถึงแม้ว่าตัวอย่างเหล่านี้
                มักมีการใช้งานในบริษัทที่เน้นเทคโนโลยีในประเทศที่พัฒนาแล้ว
                เราก็สามารถออกแบบ
                และนำเทคโนโลยีในลักษณะเดียวกันมาปรับใช้งานในประเทศของเราได้
                เพื่อเพิ่มประสิทธิภาพ ลดค่าใช้จ่าย
                และเวลารวมทั้งอำนวยความสะดวกให้กับผู้บริโภคในระดับที่ยอดเยี่ยมกว่าการพึ่งแรงงานคนเพียงอย่างเดียวได้
              </p>
            </div>
          </div>

          <img
            src='/images/ai/textile/feature5.jpg'
            srcSet='/images/ai/textile/feature5@2x.jpg 2x'
            alt='Textile'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>
    </React.Fragment>
  )
}

Textile.getLayout = function getLayout(page: React.ReactElement) {
  return <AISolutionDetailLayout>{page}</AISolutionDetailLayout>
}
